import {
  ButtonGroup,
  List,
  ListItem,
  LegacyModal,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalTrigger,
  PrimaryButton,
  Text,
  Link,
} from "@certn/cascadia-react";
import { weights } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";
import { Trans, useTranslation } from "react-i18next";

export function SecondaryInfoModal() {
  const { t } = useTranslation();

  return (
    <ModalTrigger
      trigger={() => (
        <Link
          textStyle="global/body-secondary"
          textColor="text-info"
          testID="identification-documents-secondary-document-whats-this-button"
        >
          <Trans>What's this?</Trans>
        </Link>
      )}
    >
      {(close) => (
        <LegacyModal>
          <ModalHeader close={close} title={t("Secondary document")} />
          <ModalContent>
            <Text style="global/body-primary">
              <Trans>
                Secondary use in community documents. The following documents
                are accepted:
              </Trans>
            </Text>
            <br />
            <br />
            <List type="unordered">
              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Certificate of identity
                  </strong>{" "}
                  issued by DFAT to refugees and non-Australian citizens for
                  entry to Australia
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Document of identity
                  </strong>{" "}
                  issued by DFAT to Australian citizens or persons who have the
                  nationality of a Commonwealth country for travel purposes
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Convention travel document secondary (United Nations)
                  </strong>{" "}
                  issued by DFAT
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Foreign government issued documents
                  </strong>{" "}
                  (for example, drivers licence)
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Medicare card
                  </strong>
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    A relationship certificate
                  </strong>{" "}
                  issued by a state or territory Births, Deaths and Marriages
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Enrollment with the Australian Electoral Commission
                  </strong>
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Security guard or crowd control photo licence
                  </strong>
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Evidence of right to an Australian Government benefit
                    (Centrelink or Veterans’ Affairs)
                  </strong>
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Consular photo identity card
                  </strong>{" "}
                  issued by DFAT
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Photo identity card issued to an officer by a police force
                  </strong>
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Photo identity card issued by the Australian Defence Force
                  </strong>
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Photo identity card issued by the Australian Government or a
                    state or territory government
                  </strong>{" "}
                  (this may take the form of a Working with Children/Vulnerable
                  People Card or a government occupational licence)
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Aviation Security Identification Card (ASIC)
                  </strong>
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Maritime Security Identification Card (MSIC)
                  </strong>
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Firearms licence
                  </strong>
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Credit reference check
                  </strong>
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Australian secondary or tertiary student photo identity
                    document
                  </strong>
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Certified academic transcript
                  </strong>{" "}
                  from an Australian university or a registered higher education
                  provider
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Trusted referees report
                  </strong>
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Bank card, credit card or bank statement
                  </strong>{" "}
                  (without recording the payment/card numbers)
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Australian tax file number
                  </strong>
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    State/territory government rates assessment notice or
                    Australian Taxation Office assessment notice
                  </strong>
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Australian utility bill showing name and address
                  </strong>
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Australian private health insurance card
                  </strong>
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Australian trade association card
                  </strong>
                </Trans>
              </ListItem>
            </List>
          </ModalContent>
          <ModalFooter>
            <ButtonGroup>
              <PrimaryButton onPress={close} size="medium">
                <Trans>Okay</Trans>
              </PrimaryButton>
            </ButtonGroup>
          </ModalFooter>
        </LegacyModal>
      )}
    </ModalTrigger>
  );
}
